import { defineMessages } from 'react-intl';

export default defineMessages({
    followingUwIssues: {
        id: 'ml.gateway.quoteandbind.common.uwissues.followingUwIssues',
        defaultMessage: 'The following underwriting issues have been identified:'
    },
    refreshIssuesList: {
        id: 'ml.gateway.quoteandbind.common.uwissues.refreshIssuesList',
        defaultMessage: 'REFRESH ISSUES LIST'
    },
    reviewAndApprove: {
        id: 'ml.gateway.quoteandbind.common.uwissues.reviewAndApprove',
        defaultMessage: 'Please review and APPROVE if you elect to continue with the quote'
    },
    ineligibleQuote: {
        id: 'ml.gateway.quoteandbind.common.uwissues.ineligibleQuote',
        defaultMessage: 'Quote is ineligible'
    },
    unableToContinueWithQuote: {
        id: 'ml.gateway.quoteandbind.common.uwissues.unableToContinueWithQuote',
        defaultMessage: 'We are unable to continue with this quote.'
    },
    reason: {
        id: 'ml.gateway.quoteandbind.common.uwissues.reason',
        defaultMessage: 'REASON: '
    },
    approve: {
        id: 'ml.gateway.quoteandbind.common.uwissues.approve',
        defaultMessage: 'APPROVE'
    },
    reject: {
        id: 'ml.gateway.quoteandbind.common.uwissues.reject',
        defaultMessage: 'REJECT'
    },
    submissionPrefix: {
        id: 'ml.gateway.quoteandbind.common.uwissues.submissionPrefix',
        defaultMessage: 'Submission #'
    },
    uwApprovalRequired: {
        id: 'ml.gateway.quoteandbind.common.uwissues.uwApprovalRequired',
        defaultMessage: 'Underwriting approval required'
    },
    approvalCall: {
        id: 'ml.gateway.quoteandbind.common.uwissues.approvalCall',
        defaultMessage: 'For approval, chat or call underwriting at {number}'
    },
    iaOrPcsNumber: {
        id: 'ml.gateway.quoteandbind.common.uwissues.iaOrPcsNumber',
        defaultMessage: '1-800-255-0332'
    },
    nonIaOrPcsNumber: {
        id: 'ml.gateway.quoteandbind.common.uwissues.nonIaOrPcsNumber',
        defaultMessage: '1-877-638-0506'
    },
    hideAllIssues: {
        id: 'ml.gateway.quoteandbind.common.uwissues.hideAllIssues',
        defaultMessage: 'Hide all issues'
    },
    showAllIssues: {
        id: 'ml.gateway.quoteandbind.common.uwissues.showAllIssues',
        defaultMessage: 'Show all issues'
    },
    approvedRejectedOnDate: {
        id: 'ml.gateway.quoteandbind.common.uwissues.approvedRejectedOnDate',
        defaultMessage: '{approvedOrRejected} by {name} on {date}'
    },
    approved: {
        id: 'ml.gateway.quoteandbind.common.uwissues.approved',
        defaultMessage: 'Approved'
    },
    rejected: {
        id: 'ml.gateway.quoteandbind.common.uwissues.rejected',
        defaultMessage: 'Rejected'
    },
    uwHOPBR10037: {
        id: 'ml.gateway.quoteandbind.common.uwissues.uwHOPBR10037',
        defaultMessage: '<div>The lack of a Texas Wind Inspection Certificate for entire building. <br></br> If you need more information on the TX Windstorm Inspection Program or would like to find a certified inspector visit the following website: <a>http://www.tdi.texas.gov/wind/index.html</a></div>'
    },
    uwHOPBR10064: {
        id: 'ml.gateway.quoteandbind.common.uwissues.uwHOPBR10064',
        defaultMessage: '<div>Your underlying flood coverage amount not equal to your replacement cost amount. You can learn more about the National Flood Insurance Program at <a>www.nfipservices.com</a>.</div>'
    },
    uwHOPBR10065: {
        id: 'ml.gateway.quoteandbind.common.uwissues.uwHOPBR10065',
        defaultMessage: '<div>Your underlying flood coverage amount not equal to your replacement cost amount. You can learn more about the National Flood Insurance Program at <a>www.nfipservices.com</a>.</div>'
    },
    //Decline Code 
    DeclinationOptions: {
        id: 'ml.gateway.quoteandbind.common.uwissues.DeclinationOptions',
        defaultMessage: 'Declination Notification Options'
    },
    DeclinationMessage: {
        id: 'ml.gateway.quoteandbind.common.uwissues.DeclinationMessage',
        defaultMessage: "The customer's application is ineligible due to one or more underwriting guidelines. The risk is being declined and requires the customer to be notified of the declination reason(s). Please select one of the options below to provide the customer the information. Note: Once a delivery method is selected the quote will no longer be accessible. If no delivery option is selected, a letter will be sent to the customer by mail within the next 14 to 20 days."
    },
    coloradoAlternative: {
        id: 'ml.gateway.quoteandbind.common.uwissues.coloradoAlternative',
        defaultMessage: "In the state of Colorado, an alternative to declination is an offer to issue the policy after excluding from coverage the person whose claim experience or driving record does not meet guidelines. Please advise the applicant they must sign the named driver exclusion form to continue to purchase this policy."
    },
    emailNotice: {
        id: 'ml.gateway.quoteandbind.common.uwissues.emailNotice',
        defaultMessage: 'Email Notice'
    },
    ReadtoCustomer: {
        id: 'ml.gateway.quoteandbind.common.uwissues.ReadtoCustomer',
        defaultMessage: 'Read to Customer'
    },
    DownloadForm: {
        id: 'ml.gateway.quoteandbind.common.uwissues.DownloadForm',
        defaultMessage: 'Download Form'
    },
    declineQuote:
    {
        id:"ml.gateway.quoteandbind.common.uwissues.declineQuote",
         defaultMessage: 'Decline Quote'
    },
    invalidEmail:{
        id:'ml.gateway.quoteandbind.common.uwissues.invalidEmail',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    },
    emailAddress:{
        id:'ml.gateway.quoteandbind.common.uwissues.emailAddress',
        defaultMessage:"Email"
    },
    continue:{
        id:'ml.gateway.quoteandbind.common.uwissues.continue',
        defaultMessage:"Continue"
    },
    cancel:{
        id:'ml.gateway.quoteandbind.common.uwissues.cancel',
        defaultMessage:"Cancel"
    },
    quoteWillDecline:{
        id: "ml.gateway.quoteandbind.common.uwissues.quoteWillDecline",
        defaultMessage: "Quote will be declined. Please confirm if you want to proceed."
    },
    WantToDownload:{
        id: "ml.gateway.quoteandbind.common.uwissues.WantToDownload",
        defaultMessage: "Are you sure you want to download?"
    }
});
